import { render, staticRenderFns } from "./CandidateCard.vue?vue&type=template&id=9d2c3ef8&scoped=true&"
import script from "./CandidateCard.vue?vue&type=script&lang=js&"
export * from "./CandidateCard.vue?vue&type=script&lang=js&"
import style0 from "./CandidateCard.vue?vue&type=style&index=0&id=9d2c3ef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2c3ef8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VSheet})
